/**
 * Specifies the yield calculation treatment for the index.
 * tag: 40796
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentStreamRateTreatment {
  /** Bond equivalent yield */
  BondEquivalentYield = 0,
  /** Money market yield */
  MoneyMarketYield = 1,
}
